import {
  getCompanyEmployees,
  getCourtCases,
  getNeighbors,
  getDomainCerts,
  getCrypto,
  getSanctions,
  getReports,
} from "../../../api/wiki";
import bolpng from "../../../assets/images/wiki/bol.png";
import employeepng from "../../../assets/images/wiki/employee.png";
import courtpng from "../../../assets/images/wiki/court.png";
import sanctionpng from "../../../assets/images/wiki/sanction.png";
import govpng from "../../../assets/images/wiki/gov.png";
import cryptopng from "../../../assets/images/wiki/crypto.png";
import domainpng from "../../../assets/images/wiki/domain.png";
import neigborpng from "../../../assets/images/wiki/neighbor.png";
import reportspng from "../../../assets/images/wiki/reports.png";
import TileEmployee from "./tiles/TileEmployee";
import TileCourtCase from "./tiles/TileCourtCase";
import TileNeighbor from "./tiles/TileNeighbor";
import TileDomain from "./tiles/TileDomain";
import TileCrypto from "./tiles/TileCrypto";
import TileSanction from "./tiles/TileSanction";
import TileReport from "./tiles/TileReport";

export const SYMBOL_MAP = {
  Polygon: "matic",
  Arbitrum: "arbi",
  Dogecoin: "doge",
  Bitcoin: "btc",
  Ethereum: "eth",
  Solana: "sol",
  "USD Coin": "usdc",
  Tether: "usdt",
};

export const SECTION_CONFIG = [
  { key: "Court Cases", image: courtpng, color: "#907b66", valueKey: "count" },
  { key: "BOLs", image: bolpng, color: "#7495a7", valueKey: null },
  {
    key: "Key Employees",
    image: employeepng,
    color: "#f27b07",
    valueKey: "length",
  },
  { key: "Neighbors", image: neigborpng, color: "#021317", valueKey: "length" },
  { key: "Sanctions", image: sanctionpng, color: "#9f260d", valueKey: "count" },
  { key: "Domains", image: domainpng, color: "#071d30", valueKey: "items" },
  { key: "Gov Awards", image: govpng, color: "#065e00", valueKey: null },
  { key: "Crypto", image: cryptopng, color: "#1f334a", valueKey: "length" },
  { key: "Reports", image: reportspng, color: "#262626", valueKey: "count" },
];

const str = (v) => (typeof v === "string" ? v.trim() : "");
const toStr = (v) =>
  typeof v === "string" ? v.trim() : typeof v === "number" ? String(v) : "";

export const TILE_CONFIG = {
  "Key Employees": {
    fetcher: getCompanyEmployees,
    Component: TileEmployee,
    canRender: (d) => {
      const jr = d?.json_response;
      if (!jr?.profile) return false;
      return !!(
        jr.headline ||
        jr.name ||
        jr.location ||
        (Array.isArray(jr.experience) && jr.experience.length > 0)
      );
    },
  },
  "Court Cases": {
    fetcher: getCourtCases,
    Component: TileCourtCase,
    canRender: (d) =>
      !!(
        str(d.case_name) ||
        str(d.content) ||
        str(d.date_filed) ||
        str(d.docket_number)
      ),
  },
  Neighbors: {
    fetcher: getNeighbors,
    Component: TileNeighbor,
    canRender: (d) => !!(toStr(d.neighbor) || toStr(d.url) || toStr(d.address)),
  },
  Domains: {
    fetcher: getDomainCerts,
    Component: TileDomain,
    canRender: (d) =>
      !!(
        toStr(d.url) ||
        toStr(d.cert_id) ||
        toStr(d.common_name) ||
        toStr(d.issuer_ca_id) ||
        toStr(d.issuer_name) ||
        toStr(d.name_value) ||
        toStr(d.serial_number)
      ),
  },
  Sanctions: {
    fetcher: getSanctions,
    Component: TileSanction,
    canRender: (d) => !!toStr(d.sanctions_title),
  },
  Crypto: {
    fetcher: getCrypto,
    Component: TileCrypto,
    canRender: (d) => !!(str(d.coin) || str(d.title) || str(d.address)),
  },
  Reports: {
    fetcher: getReports,
    Component: TileReport,
    canRender: (d) => !!(str(d.target_type) || str(d.content)),
    noActionWrapper: true,
  },
};

export const GRID_SECTIONS = [
  "Key Employees",
  "Court Cases",
  "Neighbors",
  "Domains",
  "Sanctions",
  "Gov Awards",
  "BOLs",
  "Crypto",
  "Reports",
];
